import { OHLCVChart } from '@src/components/OHLCVChart/OHLCVChart';
import { useDeepDiveContext } from '@src/providers/DeepDiveProvider';
import { Box } from '@talos/kyoko';
import { useMemo } from 'react';

export function MobileHistoricalPriceChartModule() {
  const {
    security,
    selectedExchangeMarkets,
    securityExchangeMarkets,
    chartResolution,
    setChartResolution,
    annotations,
    chartType,
    setAnnotations,
    setChartType,
  } = useDeepDiveContext();

  const markets = useMemo(() => {
    return selectedExchangeMarkets.length > 0 ? selectedExchangeMarkets : securityExchangeMarkets;
  }, [selectedExchangeMarkets, securityExchangeMarkets]);

  if (!security) {
    return null;
  }

  return (
    <Box overflow="hidden" flex={1}>
      <OHLCVChart
        key={security.Symbol}
        symbol={security.Symbol}
        markets={markets}
        resolution={chartResolution ?? '1H'}
        onResolutionChange={setChartResolution}
        onAnnotationsChange={setAnnotations}
        onChartTypeChange={setChartType}
        annotations={annotations}
        chartType={chartType}
        onSymbolChange={undefined}
      />
    </Box>
  );
}
